import React from 'react';
import bemCn from 'bem-cn';
import { RouteFormatter } from '../../routes';
import BlogSocial from '../blog-social';
import PictureSet from '../picture-set';

const b = bemCn('sniff-blog-post');

export const BlogAuthorDetails = ({ author, useStateSSR }) => {
    if (!author) {
        return '';
    }

    return (
        <div className={b('author-box')}>
            <div className="d-none d-md-flex">
                <PictureSet
                    imgs={author.photo}
                    isAvatar
                    width={144}
                    height={144}
                    useState={useStateSSR}
                    SSR={!!useStateSSR}
                    alt={author.name + ' photo'}
                    className="img-circle"
                />
            </div>
            <div>
                <div className={b('author-box_mob-header')}>
                    <PictureSet
                        imgs={author.photo}
                        isAvatar
                        width={144}
                        height={144}
                        useState={useStateSSR}
                        SSR={!!useStateSSR}
                        alt={author.name + ' photo'}
                        className="d-md-none img-circle"
                    />
                    <div>
                        <a href={RouteFormatter.blogAuthor({ slug: author.slug })}>
                            <h3 className="snif-m1 snif-semibold mb-1">{author.name}</h3>
                        </a>
                        <p className={b('author-box_about')}>About the author</p>
                    </div>
                </div>
                <div className={b('author-box_desc')} dangerouslySetInnerHTML={{ __html: author.description }} />
                <p className="snif-s1 snif-medium text-primary text-underline mt-1">
                    <a href={RouteFormatter.blogAuthor({ slug: author.slug })}>Read more</a>
                </p>
                <BlogSocial {...{ blogAuthor: author }} />
            </div>
        </div>
    );
};
